// There different types of incoming call data from crm like:
// Call with Unknown entity (Unknown phone),
// Call with Oleg Kar (442045202074),
// Call with Unknown (305),
// Call with Oleg Kar (442045202074), transferred to conference 111773705561
// Voice conversation with Vlaad Personal 48886640610
// All of them should have only First name and Last name, or Unknown.
export const getFullName = (fullName: string, text: string | null): string => {
  if (!text && !fullName) return 'Unknown';

  if (fullName && !fullName.toLowerCase().includes('unknown')) {
    return fullName;
  }

  if (fullName && !text) {
    return 'Unknown';
  }

  if (text.startsWith('Voice conversation with')) {
    return text
      .replace(/^Voice conversation with\s+/, '')
      .replace(/\d+$/, '')
      .trim();
  }

  const parsedName = text
    .replace(/^Call with\s+/, '')
    .replace(/\s*\([^()]*\).*$/, '')
    .trim();

  if (parsedName === 'Unknown entity') {
    return 'Unknown';
  }

  return parsedName;
};
